var _path, _path2, _path3, _g, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrbIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29539 7.79187C3.05064 8.19608 2.83836 8.61581 2.65924 9.04722C1.96534 10.7184 1.76905 12.5647 2.11091 14.3614C2.54102 16.6218 3.79276 18.6449 5.62657 20.0434C7.46037 21.4419 9.74746 22.1176 12.0501 21.9413C14.3528 21.7649 16.5093 20.7488 18.107 19.0875C19.7046 17.4262 20.6313 15.2363 20.7095 12.9369C20.7877 10.6376 20.012 8.39024 18.5309 6.625C17.0497 4.85976 14.9672 3.70061 12.6818 3.36939C10.8653 3.10612 9.02205 3.38059 7.37574 4.14282C6.95076 4.33959 6.5389 4.56885 6.14402 4.82976L7.02971 6.16009C8.62569 5.10559 10.556 4.67442 12.4511 4.94909C14.3462 5.22375 16.0732 6.18497 17.3014 7.64877C18.5296 9.11258 19.1728 10.9762 19.108 12.8829C19.0431 14.7896 18.2747 16.6056 16.9499 17.9832C15.625 19.3608 13.8368 20.2034 11.9273 20.3496C10.0178 20.4959 8.12129 19.9355 6.60062 18.7758C5.07995 17.6161 4.04197 15.9385 3.6853 14.0641C3.32864 12.1897 3.67835 10.25 4.66751 8.61639L3.29539 7.79187Z",
    fill: "url(#paint0_linear_3549_82937)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4959 24C19.7058 24 19.9158 23.9204 20.0762 23.7611C20.3965 23.4429 20.3965 22.9269 20.0762 22.6087L1.40079 4.02183C1.08046 3.70366 0.560524 3.70366 0.240628 4.02183C-0.0796986 4.34001 -0.0796986 4.85602 0.240628 5.1742L18.916 23.7611C19.0759 23.9204 19.2859 24 19.4959 24Z",
    fill: "url(#paint1_linear_3549_82937)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3549_82937",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 20,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29539 7.79187C3.05064 8.19608 2.83836 8.61581 2.65924 9.04722C1.96534 10.7184 1.76905 12.5647 2.11091 14.3614C2.54102 16.6218 3.79276 18.6449 5.62656 20.0434C7.46037 21.4419 9.74746 22.1176 12.0501 21.9413C14.3528 21.7649 16.5093 20.7488 18.107 19.0875C19.7046 17.4262 20.6313 15.2363 20.7095 12.9369C20.7877 10.6376 20.012 8.39024 18.5309 6.625C17.0497 4.85976 14.9672 3.70061 12.6818 3.36939C10.8653 3.10612 9.02205 3.38059 7.37574 4.14282C6.95076 4.33959 6.5389 4.56885 6.14401 4.82976L7.02971 6.16009C8.62569 5.10559 10.556 4.67442 12.4511 4.94909C14.3462 5.22375 16.0732 6.18497 17.3014 7.64877C18.5296 9.11258 19.1728 10.9762 19.108 12.8829C19.0431 14.7896 18.2747 16.6056 16.9499 17.9832C15.625 19.3608 13.8368 20.2034 11.9273 20.3496C10.0178 20.4959 8.12129 19.9355 6.60062 18.7758C5.07995 17.6161 4.04196 15.9385 3.6853 14.0641C3.32864 12.1897 3.67835 10.25 4.66751 8.61639L3.29539 7.79187Z",
    fill: "url(#paint2_linear_3549_82937)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3549_82937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13069 8.03642C8.19117 7.84469 8.24871 7.6508 8.29522 7.45605C8.30536 7.41575 8.31549 7.37545 8.32314 7.33598C8.34724 7.24391 8.36542 7.15016 8.384 7.05895C8.4089 6.93632 8.43042 6.8116 8.4498 6.68983C8.45107 6.68137 8.45316 6.67539 8.45188 6.66733C8.46957 6.55409 8.48561 6.44415 8.50035 6.32877C8.50919 6.24476 8.52011 6.15737 8.52551 6.07086C8.52933 6.04286 8.53308 6.01444 8.53388 5.98388C8.5389 5.92786 8.5435 5.87191 8.54598 5.81629C8.55185 5.73275 8.5547 5.64664 8.55798 5.56046C8.56041 5.45528 8.75092 5.66501 8.75081 5.56023C8.16876 4.97325 7.37022 4.0815 6.73299 3.5115C6.85849 4.05743 6.16652 3.41083 6.17019 3.97337C6.07239 3.87834 6.73302 4.99038 6.63309 4.8983L6.50902 6.65331C6.59148 6.72031 6.67139 6.78772 6.75426 6.85727C6.89456 6.97603 7.03776 7.09389 7.17806 7.21265C7.49649 7.48551 7.8157 7.75781 8.13069 8.03642Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7272 17.7618C16.7961 17.7114 17.1284 17.5814 17.1964 17.5282C17.4942 17.2952 17.7773 17.2062 18.0327 16.9378C18.4248 17.3475 18.8065 17.7317 19.1847 18.0986C18.8864 18.4068 18.4768 18.8959 18.1348 19.1642C17.7312 18.7816 17.1425 18.1298 16.7272 17.7618Z",
    fill: "black",
    fillOpacity: 0.15
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1795 23.005C23.3894 23.005 23.5994 22.9254 23.7598 22.7661C24.0801 22.4479 24.0801 21.9319 23.7598 21.6137L2.24008 0.238631C1.91976 -0.0795437 1.39982 -0.0795437 1.07992 0.238631C0.759593 0.556806 0.759593 1.07282 1.07992 1.391L22.5996 22.7661C22.7595 22.9254 22.9695 23.005 23.1795 23.005Z",
    fill: "url(#paint3_linear_3549_82937)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3549_82937",
    x1: 20.9105,
    y1: 24.8805,
    x2: 2.19022,
    y2: 5.40608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5493F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3549_82937",
    x1: 7.72764,
    y1: 12.5627,
    x2: 0.122528,
    y2: 4.62832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5493F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3549_82937",
    x1: 20.9105,
    y1: 24.8805,
    x2: 2.19022,
    y2: 5.40608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5493F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3549_82937",
    x1: 24.2414,
    y1: 26.5877,
    x2: 1.21027,
    y2: 2.55868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5493F7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbIcn);
export default __webpack_public_path__ + "static/media/orb-icn.0135d9c903aad175d529d596b688dfeb.svg";
export { ForwardRef as ReactComponent };